/**
 * PlaylistTileHoverShell — always-mounted hover panel matching the
 * style/size of `tile-v2__info--hovered` (Tile.v2).
 *
 * The panel is positioned absolutely over the parent
 * `.playlist-search-tile` with `top: 0; left: 50%; width: 100%`. It sits
 * at `scale(1.0)` invisible by default and animates to `scale(1.4)` when
 * the parent passes `hoverActive={true}` (which fires after the 450 ms
 * hover delay coordinated by PlaylistTileShell).
 *
 * Render strategy: always mounted (toggle a CSS class) so the
 * `transform` transition runs in *both* directions. The previous
 * implementation conditionally mounted the panel and only fades opacity,
 * which produced a one-way animation.
 *
 * Each variation passes its unique hover-body content as `children`.
 */

import React from 'react'

interface PlaylistTileHoverShellProps {
  hoverActive: boolean
  children: React.ReactNode
}

function PlaylistTileHoverShell ({
  hoverActive,
  children,
}: PlaylistTileHoverShellProps): React.ReactElement {
  const className = hoverActive
    ? 'playlist-search-tile__hover-card playlist-search-tile__hover-card--hovered'
    : 'playlist-search-tile__hover-card'

  return (
    <div className={className} aria-hidden={!hoverActive}>
      <div className="playlist-search-tile__hover-body">
        {children}
      </div>
    </div>
  )
}

export default PlaylistTileHoverShell
